"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResize = void 0;
var react_1 = require("react");
var useResize = function (x, y, width, height, onResize) {
    var _a = (0, react_1.useState)(false), dragging = _a[0], setDragging = _a[1];
    var _b = (0, react_1.useState)({
        initX: 0,
        initY: 0,
        initWidth: 0,
        initHeight: 0,
        mouseDownX: 0,
        mouseDownY: 0
    }), initialDragState = _b[0], setInitialDragState = _b[1];
    var onMouseDown = (0, react_1.useCallback)(function (e) {
        e.preventDefault();
        setInitialDragState({
            initX: x,
            initY: y,
            initWidth: width,
            initHeight: height,
            mouseDownX: e.clientX,
            mouseDownY: e.clientY
        });
        setDragging(true);
    }, [width, height, setDragging, setInitialDragState, x, y]);
    (0, react_1.useEffect)(function () {
        var onMouseMove = function (e) {
            if (dragging) {
                var initX = initialDragState.initX, initY = initialDragState.initY, initWidth = initialDragState.initWidth, mouseDownX = initialDragState.mouseDownX, initHeight = initialDragState.initHeight, mouseDownY = initialDragState.mouseDownY;
                var dx = e.clientX - mouseDownX;
                var dy = e.clientY - mouseDownY;
                var width_1 = initWidth + dx;
                var height_1 = initHeight + dy;
                return onResize({ width: width_1, height: height_1, x: initX, y: initY });
            }
        };
        window.addEventListener('mousemove', onMouseMove, { passive: true });
        return function () { return window.removeEventListener('mousemove', onMouseMove); };
    }, [initialDragState, dragging, onResize]);
    (0, react_1.useEffect)(function () {
        var onMouseUp = function () {
            setDragging(false);
        };
        window.addEventListener('mouseup', onMouseUp);
        return function () { return window.removeEventListener('mouseup', onMouseUp); };
    }, [setDragging]);
    return onMouseDown;
};
exports.useResize = useResize;
